module.exports = __webpack_public_path__ + "img/mobile_girl_two.a26a99cc.png";